<div class="page-container">
<div class="card p-3 m-3">
  <div class="row px-3 mb-2">
    <div class="statistics mb-2 d-flex align-items-end gap-3" style="justify-content: space-between;">
      <a routerLink="/statistics" class="statistics-link d-flex align-items-center gap-2">
        <h2 class="mb-0">
          <b style="color: black;">Statistiche Giorni Operativa</b>
        </h2>
        <i class="fas fa-reply return-icon"></i>
      </a>
      <div class="d-flex gap-2" style="justify-content: space-between;">
        <div class="ms-auto">
          <div class="statistics-toggle-group">
            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleCertification === 'on_time'"
              (click)="onToggleCertification('on_time')">
              <i class="fas fa-clock"></i>
              On time
            </button>

            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleCertification === 'in_range'"
              (click)="onToggleCertification('in_range')">
              <i class="fas fa-map-pin"></i>
              In range
            </button>
          </div>
        </div>
        <div class="ms-auto">
          <div class="statistics-toggle-group">
            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleTotal === 'totale_affidati'"
              (click)="onToggleTotal('totale_affidati')">
              <i class="fa-solid fa-handshake"></i>
              Su totale affidati
            </button>

            <button 
              type="button"
              class="statistics-toggle-btn"
              [class.active]="selectedToggleTotal === 'totale_consegnati'"
              (click)="onToggleTotal('totale_consegnati')">
              <i class="fas fa-shipping-fast"></i>
              Su totale consegnati
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- FILTRI IN RIGA -->
    <form (ngSubmit)="fetchStatistics()">

      <div class="d-flex justify-content-between">
        <div class="d-flex flex-wrap gap-3 mb-3">

          <div class="filter-item" style="min-width: 200px;" *ngIf="filteredClients.length > 1">
            <label class="form-label">Clienti</label>
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown
                *ngIf="filteredClients.length > 0 && dropdownSettingsClient"
                name="clients"
                [placeholder]="'Seleziona clienti'"
                [settings]="dropdownSettingsClient"
                [data]="filteredClients"
                [(ngModel)]="selectedClients"
                [ngModelOptions]="{standalone: true}"
                (onSelect)="onClientsChange()"
                (onDeSelect)="onClientsChange()"
                (onSelectAll)="selectAllClients()"
                (onDeSelectAll)="deselectAllClients()"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="filter-item" style="min-width: 200px;" *ngIf="filteredBrands.length > 1">
            <label class="form-label">Marchi</label>
            <div class="multi-select-wrapper">
              <ng-multiselect-dropdown *ngIf="filteredBrands.length > 0 && dropdownSettingsBrand"
                name="brands"
                [placeholder]="'Seleziona marchi'"
                [settings]="dropdownSettingsBrand"
                [data]="filteredBrands"
                [(ngModel)]="selectedBrands"
                [ngModelOptions]="{standalone: true}"
                >
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Tipologia</label>
            <select class="form-select" [(ngModel)]="scheduleType" name="scheduleType">
              <option value="">Tutte</option>
              <option value="AxA">DMDC</option>
              <option value="AxB">A*B</option>
              <option value="AxC">A*C</option>
              <option value="AxD">A*D</option>
            </select>
          </div>

          <!-- Filtro Night/Day -->
          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Night/Day</label>
            <select class="form-select" [(ngModel)]="scheduleIsNight" name="scheduleIsNight" [disabled]="scheduleType !== 'AxB'">
              <option value="">Tutti</option>
              <option value="Y">Night</option>
              <option value="N">Day</option>
            </select>
          </div>

          <div class="filter-item" style="min-width: 150px;">
            <label class="form-label">Metodo</label>
            <select class="form-select" [(ngModel)]="scheduleMethod" name="scheduleMethod" [disabled]="scheduleType !== 'AxB'">
              <option value="">Tutti</option>
              <option value="BY_ROAD">Via terra</option>
              <option value="BY_AIR">Via aerea</option>
            </select>
          </div>

          <!-- <div class="filter-item" style="min-width: 130px;">
            <label class="form-label">Data Inizio</label>
            <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">
          </div> -->

          <!-- <div class="filter-item" style="min-width: 130px;">
            <label class="form-label">Data Fine</label>
            <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
          </div> -->

          <div class="mb-2 d-flex">
            <div class="filter-item" style="min-width: 180px;">
              <label style="padding-left:30px;" class="form-label d-block">Data Inizio</label>
              <div class="d-flex align-items-center">
                <button class="date-nav-btn" type="button" (click)="decrementStartDate(); decrementEndDate()" title="Giorno precedente">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <input type="date" class="form-control" [(ngModel)]="dateStart" name="dateStart">

              </div>
            </div>

            <div class="filter-item" style="min-width: 180px;">
              <label class="form-label">Data Fine</label>
              <div class="d-flex align-items-center">
                <input type="date" class="form-control" [(ngModel)]="dateEnd" name="dateEnd">
                <button class="date-nav-btn" type="button" (click)="incrementStartDate(); incrementEndDate()" title="Giorno successivo">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-item mt-3">
            <div class="custom-switch-btn d-flex align-items-center">
              <i class="fa-solid fa-scale-unbalanced me-2"></i>
              <label class="form-check-label me-2" for="showJustifyParcels" style="cursor: pointer;">
                Colli giustificati
              </label>
              <div class="form-check form-switch m-0" style="cursor: pointer;">
                <input
                  style="cursor: pointer;"
                  class="form-check-input"
                  type="checkbox"
                  id="showJustifyParcels"
                  [(ngModel)]="showJustifyParcels"
                  name="showJustifyParcels"
                  (change)="fetchStatistics()" />
              </div>
            </div>
        </div>
      
      </div>
      <!-- BOTTONE FILTRA + RESET IN RIGA A DESTRA -->
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-primary" type="submit">Applica Filtri</button>
        <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
      </div>

    </form>
  </div>
</div>


  <!-- LOADING -->
  <div *ngIf="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status"></div>
    <p>Caricamento dati...</p>
  </div>

  <!-- ERRORE -->
  <div *ngIf="error" class="alert alert-danger text-center p-3 m-3">
    {{ error }}
  </div>  

  <!-- WARNING -->
  <div *ngIf="warning" class="alert alert-warning p-3 m-3">
    <div class="d-flex align-items-center">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <span>{{ warning }}</span>
    </div>
  </div>
  
  <div class="row px-3 mb-3">
    <div class="col-12 d-flex align-items-center justify-content-end gap-2 flex-wrap flex-md-nowrap">      
      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-hash"></i></span>
        <input type="text" class="form-control" [value]="totalItems" readonly style="max-width: 80px;">
      </div>

      <div class="input-group" style="width: auto;">
        <span class="input-group-text"><i class="bi bi-view-list"></i></span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let size of [5, 10, 25, 50, 100]" [value]="size">{{size}}</option>
        </select>
      </div>
      
      <button class="btn btn-green w-auto"
              type="button"
              (click)="exportStatisticsToExcel()"
              title="Esporta Excel">
        <i class="fas fa-file-excel"></i>
      </button>
      <button class="btn btn-green w-auto"
              type="button"
              (click)="exportStatisticsCarriersToExcel()"
              title="Esporta Excel Per Vettore">
        <i class="fa-solid fa-truck-fast"></i><i class="fas fa-file-excel"></i>
      </button>
      
    </div>
  </div>
  <!-- RISULTATI -->
  <div *ngIf="stats && !loading" class="row mx-3">
    <div class="card table-container">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-bordered table-hover text-center">
            <thead class="bg-light">
  <tr>
    <!-- Sempre visibili -->
    <th>#</th>
    <th (click)="setSort('dataAffido')" style="cursor:pointer">
      Data affido
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'dataAffido' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'dataAffido' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'dataAffido'
      }"></i>
    </th>
    <th (click)="setSort('affidatiTot')" style="cursor:pointer">
      Affidati
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'affidatiTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'affidatiTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'affidatiTot'
      }"></i>
    </th>

    <th colspan="2" class="text-center">Consegnati</th>
    <th *ngIf="selectedToggleCertification === 'on_time'" colspan="2" class="text-center">Consegnati on time</th>
    <th *ngIf="selectedToggleCertification === 'in_range'"  colspan="2" class="text-center">Consegnati in range</th>
    <th colspan="2" class="text-center">Consegnati on time e in range</th>
  </tr>
  <tr>
    <th style="background-color: white !important;" colspan="3"></th>

    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('consegnatiTot')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnatiTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnatiTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnatiTot'
      }"></i>
    </th>
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('percConsegnatiTot')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percConsegnatiTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percConsegnatiTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percConsegnatiTot'
      }"></i>
    </th>

    <!-- Se on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleCertification === 'on_time'" 
        (click)="setSort('consegnatiInOrarioTot')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnatiInOrarioTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnatiInOrarioTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnatiInOrarioTot'
      }"></i>
    </th>
    <!-- Se totale_affidati + on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'" 
        (click)="setSort('percAffidatiConsegnatiInOrarioTot')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percAffidatiConsegnatiInOrarioTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percAffidatiConsegnatiInOrarioTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percAffidatiConsegnatiInOrarioTot'
      }"></i>
    </th>
    <!-- Se totale_consegnati + on_time -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'" 
        (click)="setSort('percConsegnatiInOrarioTot')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percConsegnatiInOrarioTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percConsegnatiInOrarioTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percConsegnatiInOrarioTot'
      }"></i>
    </th>

    <!-- Se in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleCertification === 'in_range'" 
        (click)="setSort('inRangeTot')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'inRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'inRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'inRangeTot'
      }"></i>
    </th>
    <!-- Se totale_affidati + in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'" 
        (click)="setSort('percAffidatiConsegnatiInRangeTot')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percAffidatiConsegnatiInRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percAffidatiConsegnatiInRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percAffidatiConsegnatiInRangeTot'
      }"></i>
    </th>
    <!-- Se totale_consegnati + in_range -->
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'" 
        (click)="setSort('percConsegnatiInRangeTot')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percConsegnatiInRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percConsegnatiInRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percConsegnatiInRangeTot'
      }"></i>
    </th>


    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" (click)="setSort('consegnatiInOrarioInRangeTot')">
      Totale
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'consegnatiInOrarioInRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'consegnatiInOrarioInRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'consegnatiInOrarioInRangeTot'
      }"></i>
    </th>
    
    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_consegnati'" (click)="setSort('percConsegnatiInOrarioInRangeTot')">
      % (su totale consegnati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percConsegnatiInOrarioInRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percConsegnatiInOrarioInRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percConsegnatiInOrarioInRangeTot'
      }"></i>
    </th>  

    <th style="background-color: #0d6efd0f !important;cursor:pointer !important;" *ngIf="selectedToggleTotal === 'totale_affidati'" (click)="setSort('percAffidatiConsegnatiInOrarioInRangeTot')">
      % (su totale affidati)
      <i class="bi" [ngClass]="{
        'bi-arrow-down': sortState.active === 'percAffidatiConsegnatiInOrarioInRangeTot' && sortState.direction === 'desc',
        'bi-arrow-up': sortState.active === 'percAffidatiConsegnatiInOrarioInRangeTot' && sortState.direction === 'asc',
        'bi-arrow-down-up': sortState.active !== 'percAffidatiConsegnatiInOrarioInRangeTot'
      }"></i>
    </th>  

  </tr>
</thead>


<tbody>
  <ng-container *ngFor="let stat of getPaginatedStats(); let i = index">
    <!-- RIGA PADRE -->
    <tr (click)="toggleExpand(stat)" class="parent-statistic-row"
        [class.table-active]="expandedDay === stat">
      <td class="expand-icon">
        <i class="bi" [ngClass]="expandedDay === stat ? 'bi-caret-down-fill' : 'bi-caret-right-fill'"></i>
      </td>

      <!-- <td>{{ pageIndex * pageSize + i + 1 }}</td> -->
      <td>{{ stat.dataAffido | date: 'dd/MM/yyyy' }}</td>
      <td>{{ stat.affidatiTot }}</td>

      <td>{{ stat.consegnatiTot }}</td>
      <td>{{ stat.percConsegnatiTot | number: '1.0-2' }}%</td>

      <!-- on_time -->
      <td *ngIf="selectedToggleCertification === 'on_time'">
        {{ stat.consegnatiInOrarioTot }}
      </td>
      <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'">
        {{ stat.percAffidatiConsegnatiInOrarioTot | number: '1.0-2' }}%
      </td>
      <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'">
        {{ stat.percConsegnatiInOrarioTot | number: '1.0-2' }}%
      </td>

      <!-- in_range -->
      <td *ngIf="selectedToggleCertification === 'in_range'">
        {{ stat.inRangeTot }}
      </td>
      <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'">
        {{ stat.percAffidatiConsegnatiInRangeTot | number: '1.0-2' }}%
      </td>
      <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'">
        {{ stat.percConsegnatiInRangeTot | number: '1.0-2' }}%
      </td>

      <!-- on_time + in_range -->
      <td>{{ stat.consegnatiInOrarioInRangeTot }}</td>
      <td *ngIf="selectedToggleTotal === 'totale_consegnati'" >
        <div class="progress-bar-wrapper">
          <div class="progress-bar-inner"
              [ngStyle]="{
                'width.%': stat.percConsegnatiInOrarioInRangeTot,
                'background-color': stat.percConsegnatiInOrarioInRangeTot > 97.5 ? '#90ee90' :
                                    (stat.percConsegnatiInOrarioInRangeTot >= 60 ? '#fff176' : '#f28b82')
              }">
          </div>
          <span class="progress-bar-label">
            {{ stat.percConsegnatiInOrarioInRangeTot | number: '1.0-2' }}%
          </span>
        </div>
      </td>
      <td *ngIf="selectedToggleTotal === 'totale_affidati'" >
        <div class="progress-bar-wrapper">
          <div class="progress-bar-inner"
              [ngStyle]="{
                'width.%': stat.percAffidatiConsegnatiInOrarioInRangeTot,
                'background-color': stat.percAffidatiConsegnatiInOrarioInRangeTot > 97.5 ? '#90ee90' :
                                    (stat.percAffidatiConsegnatiInOrarioInRangeTot >= 60 ? '#fff176' : '#f28b82')
              }">
          </div>
          <span class="progress-bar-label">
            {{ stat.percAffidatiConsegnatiInOrarioInRangeTot | number: '1.0-2' }}%
          </span>
        </div>
      </td>


    </tr>


    <!-- RIGHE FIGLIE (carrier) -->
    <tr *ngIf="expandedDay === stat">
      <td colspan="12" class="p-0">
        <table class="table table-sm mx-3 text-center border rounded shadow-sm" style="width: -webkit-fill-available !important; margin-bottom: 1rem !important;">
          <thead class="table-light">
            <tr>
              <th>Vettore</th>
              <th>Transit Point</th>
              <th>Data</th>
              <th>Affidati</th>
              <th>Consegnati</th>
              <th>% Consegnati</th>

              <!-- on_time -->
              <th *ngIf="selectedToggleCertification === 'on_time'">On time</th>
              <th *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'">% On time / affidati</th>
              <th *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'">% On time / consegnati</th>

              <!-- in_range -->
              <th *ngIf="selectedToggleCertification === 'in_range'">In range</th>
              <th *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'">% In range / affidati</th>
              <th *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'">% In range / consegnati</th>

              <!-- on_time + in_range -->
              <th>On time + In range</th>
              <th *ngIf="selectedToggleTotal === 'totale_affidati'">% On time + In range / affidati</th>
              <th *ngIf="selectedToggleTotal === 'totale_consegnati'">% On time + In range / consegnati</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let carrier of stat.carriers">
              <td>{{ carrier.carrierName }}</td>
              <td>{{ carrier.warehouseName }}</td>
              <td>{{ stat.dataAffido | date: 'dd/MM/yyyy' }}</td>
              <td>{{ carrier.affidati }}</td>
              <td>{{ carrier.consegnati }}</td>
              <td>{{ carrier.percentualeConsegnati | number: '1.0-2' }}%</td>

              <!-- on_time -->
              <td *ngIf="selectedToggleCertification === 'on_time'">{{ carrier.consegnatiInOrario }}</td>
              <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'on_time'">
                {{ carrier.percentualeAffidatiConsegnatiInOrario | number: '1.0-2' }}%
              </td>
              <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'on_time'">
                {{ carrier.percentualeConsegnatiInOrario | number: '1.0-2' }}%
              </td>

              <!-- in_range -->
              <td *ngIf="selectedToggleCertification === 'in_range'">{{ carrier.inRange }}</td>
              <td *ngIf="selectedToggleTotal === 'totale_affidati' && selectedToggleCertification === 'in_range'">
                {{ carrier.percentualeAffidatiConsegnatiInRange | number: '1.0-2' }}%
              </td>
              <td *ngIf="selectedToggleTotal === 'totale_consegnati' && selectedToggleCertification === 'in_range'">
                {{ carrier.percentualeConsegnatiInRange | number: '1.0-2' }}%
              </td>

              <!-- on_time + in_range -->
              <td>{{ carrier.consegnatiInOrarioInRange }}</td>
              <td *ngIf="selectedToggleTotal === 'totale_consegnati'">
                <div class="progress-bar-wrapper">
                  <div class="progress-bar-inner"
                      [ngStyle]="{
                        'width.%': carrier.percentualeConsegnatiInOrarioInRange,
                        'background-color': carrier.percentualeConsegnatiInOrarioInRange > 97.5 ? '#90ee90' :
                                            (carrier.percentualeConsegnatiInOrarioInRange >= 60 ? '#fff176' : '#f28b82')
                      }">
                  </div>
                  <span class="progress-bar-label">
                    {{ carrier.percentualeConsegnatiInOrarioInRange | number: '1.0-2' }}%
                  </span>
                </div>
              </td>
              <td *ngIf="selectedToggleTotal === 'totale_affidati'">
                <div class="progress-bar-wrapper">
                  <div class="progress-bar-inner"
                      [ngStyle]="{
                        'width.%': carrier.percentualeAffidatiConsegnatiInOrarioInRange,
                        'background-color': carrier.percentualeAffidatiConsegnatiInOrarioInRange > 97.5 ? '#90ee90' :
                                            (carrier.percentualeAffidatiConsegnatiInOrarioInRange >= 60 ? '#fff176' : '#f28b82')
                      }">
                  </div>
                  <span class="progress-bar-label">
                    {{ carrier.percentualeAffidatiConsegnatiInOrarioInRange | number: '1.0-2' }}%
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  </ng-container>

  <tr *ngIf="getPaginatedStats().length === 0">
    <td colspan="12" class="text-center py-3">Nessuna statistica trovata</td>
  </tr>
</tbody>



    </table>        </div>
        <!-- Paginazione Bootstrap -->
        <div class="d-flex flex-column flex-md-row justify-content-end align-items-center p-2 gap-2">
      <nav aria-label="Paginazione tabella" *ngIf="totalItems > 0">
        <ul class="pagination mb-0">
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="firstPage()">
              <i class="bi bi-chevron-double-left"></i>
            </a>
          </li>
          <li class="page-item" [class.disabled]="pageIndex === 0">
            <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
              <i class="bi bi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <span class="page-link">
                Pagina {{getNumberOfPages() === 0 ? 1 : pageIndex + 1}} di
                {{getNumberOfPages() === 0 ? 1 : getNumberOfPages()}}
            </span>
          </li>
          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
              <i class="bi bi-chevron-right"></i>
            </a>
          </li>          <li class="page-item" [class.disabled]="pageIndex >= getNumberOfPages() - 1">
            <a class="page-link" href="javascript:void(0)" (click)="lastPage()">
              <i class="bi bi-chevron-double-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
      </div>
    </div>
  </div>


  



</div>